import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { endpoints } from "../../../api/ApiEndPoints";
import { setPromotionContent } from "./cl_promotionSlice";
import { useNavigate } from "react-router-dom";
import icons from "../../../assets/images/sprite-other-icons.svg";

const Promotions = () => {
  const navigate = useNavigate();

  const handleClick = (e, offerData) => {
    if (e.target.classList.contains("SB-promotionMore")) {
      e.preventDefault();
      const href = e.target.getAttribute("href");
      navigate(href, {
        state: { offerData },
      });
    }
  };

  const dispatch = useDispatch();
  const brandid = endpoints?.fasFasBrandId || 307;
  const { staticContent } = useSelector((state) => state?.promotion);

  useEffect(() => {
    if (brandid) dispatch(setPromotionContent(brandid));
  }, [dispatch, brandid]);

  const goBack = () => {
    navigate("/");
  };

  return (
    <div className="SB-page-content SB-promotion-page">
      <div className="SB-promotions">
        <div className="SB-casinoCategoryItem SB-promotions-header">
          <div className="SB-casinoCategoryItem-header">
            <div className="SB-pageBackButton SB-iconSVG" onClick={goBack}>
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#${"icon-back"}`} />
              </svg>
            </div>
            <div className="SB-casinoCategoryItem-title">Promotions</div>
          </div>
        </div>
        <div className="SB-promotions-content">
          <div className="SB-tab-content">
            {staticContent?.length > 0 ? (
              <ul className="SB-promotions-list">
                {staticContent?.map((item, index) => {
                  return (
                    <li key={index} onClick={(e) => handleClick(e, item)}>
                      {item.is_active ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.mainofferitem,
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="SB-msgBox">
                <div className="SB-msgBox-container">
                  No promotions available at the moment
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Promotions;
